import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType, FileType } from "@/common/types/common";

export async function fileList(
    owner_id: string,
    query?: QueryType
) {

    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `common/files/${owner_id}/list${queryString}`
    );
}

export async function fileGet(
    file_id: string,
) {
    return await clientAxios.get(
        `common/file/${file_id}/show`,
    );
}

export async function fileAdd(
    owner_id: string,
    payload: FileType,
) {
    return await clientAxios.post(
        `common/file/${owner_id}/add`,
        payload
    );
}

export async function filePut(
    owner_id: string,
    payload: FileType,
) {
    return await clientAxios.put(
        `common/file/${owner_id}/edit`,
        payload
    );
}

export async function fileDel(
    avatar_id: string,
) {
    return await clientAxios.del(
        `common/file/${avatar_id}/del`,
    );
}

export async function fileConvertPDFtoIMG(
    owner_id: string,
    type: string,
    name: string,
    file: string
) {
    return await clientAxios.post(
        `common/convert/pdf-image/${owner_id}`,
        { name, type, file }
    );
}
